export default __webpack_public_path__ + "static/media/Twitter.16ec4858.svg";